import * as React from "react";

const Index = () => {
  const Document = typeof document !== "undefined" && document;

  const pauseOtherVideos = (id) => {
    const otherVideo = Document.getElementById(id);
    otherVideo.pause();
  };

  const videoStyles = {
    width: "100%",
    maxWidth: "100%",
    height: "100%",
    maxHeight: "400px",
  };

  return (
    <div className="bg-light py-5">
      <div className="container my-2 my-md-5">
        <div className="text-left mb-5 pb-4 small-container">
          <h2 className="fs-1 mb-3 fw-bold">Client Testimonials</h2>
          <p className="text-muted fs-4 col-lg-8 col-md-10">
            Some feedback from Nico and Abdul, as they illuminate the
            transformative impact and outstanding outcomes of our combined
            efforts.
          </p>
        </div>

        <div className="d-flex flex-column flex-md-row">
          <div className="text-center w-100 w-md-50 mb-4 mb-md-0">
            <video
              onPlay={() => pauseOtherVideos("abdul_testimonial")}
              src="/videos/testimonials/nico-testimonial.mp4"
              poster="/videos/testimonials/poster/nico.webp"
              className="rounded hovered-cursor"
              id="nico_testimonial"
              style={videoStyles}
              playsInline
              controls
            >
              <track kind="captions" srcLang="en" />
            </video>
          </div>
          <div className="text-center w-100 w-md-50 ms-0 ms-md-4">
            <video
              onPlay={() => pauseOtherVideos("nico_testimonial")}
              src="/videos/testimonials/abdul-testimonial.mp4"
              poster="/videos/testimonials/poster/abdul.webp"
              className="rounded hovered-cursor"
              id="abdul_testimonial"
              style={videoStyles}
              playsInline
              controls
            >
              <track kind="captions" srcLang="en" />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
